
<div [@showReport]="animationState" (@showReport.done)="showReportDone()">
    <div class="report-container__wrapper" [ngStyle]="styles" [ngClass]="{'report-container--padding' : hasPadding}">
        <div #reportContainer></div>
        <app-overflow-spinner [showSpinner]="pendingValue"></app-overflow-spinner>
    </div>
</div>
